/**
 * @desc 获取设备系统中设备信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.BaseDeviceRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QueryBaseDeviceResponse>>> {
  return defHttp.post({
    url: '/wap/equipment/device',
    data,
  });
}

export function mock(
  data: defs.BaseDeviceRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QueryBaseDeviceResponse>>> {
  return defHttp.post({
    url: '/mock/wap/equipment/device',
    data,
  });
}
